module.exports = __webpack_public_path__ + "static/media/ls.5e197b48.webp";